import classNames from 'classnames';
import React, { FC } from 'react';

import '@eika/button-style';
import { IconTypes, Icon } from '@eika/icon';

type HTMLAProps = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

interface ActionLinkProps extends HTMLAProps {
    icon: IconTypes;
    href?: string;
    /**
     * changes the background color of the button
     * @default false
     */
    isSecondary?: boolean;
}

const ActionLink: FC<ActionLinkProps> = ({ children, href, className, icon, isSecondary = false, ...rest }) => {
    return (
        <a
            href={href}
            className={classNames(
                'sgw-button',
                'sgw-button-common',
                `button--action`,
                'action-link__link-element',
                'action-button__button',
                className,
                { 'action-button__button--secondary': isSecondary },
            )}
            {...rest}
        >
            <Icon type={icon} className="action-link__icon icon--36" />
            <div className="action-link__label">{children}</div>
        </a>
    );
};

export default ActionLink;
